import React from "react";
import { Link } from "react-router-dom";

export default function PoolCareBusinessFranchiseSuccess() {
  return (
    <div
      style={{
        maxWidth: 600,
        margin: "80px auto",
        padding: 30,
        textAlign: "center",
        background: "#fff",
        borderRadius: 12,
        boxShadow: "0 10px 30px rgba(0,0,0,0.05)"
      }}
    >
      <h2 style={{ marginBottom: 10 }}>✅ Payment Successful</h2>

      <p style={{ fontSize: 16 }}>
        Your Pool Care Business listing is now being activated.
      </p>

      <p style={{ color: "#666", fontSize: 14 }}>
        Stripe may take a few seconds to confirm your payment.
        Once confirmed, your listing will appear in search results.
      </p>

      <div style={{ marginTop: 30, display: "flex", justifyContent: "center", gap: 15 }}>
        <Link
          to="/my-listings"
          style={{
            padding: "10px 20px",
            background: "#2e7d32",
            color: "#fff",
            textDecoration: "none",
            borderRadius: 6
          }}
        >
          View My Listings
        </Link>

        <Link
         to="/poolcare/businesses"
          style={{
            padding: "10px 20px",
            border: "1px solid #2e7d32",
            color: "#2e7d32",
            textDecoration: "none",
            borderRadius: 6
          }}
        >
          Back to Pool Care
        </Link>
      </div>
    </div>
  );
}